import React, { useContext } from 'react';
import { StyledBody } from '../../CSSstyles';
import { LocationContext } from '../../../../ContextProviders';
import { analyticsTrackEvent } from '../../../../../../core/analytics';
import {
  CDP_COVID_TEST_SECTION,
  CDP_COVID_TEST_ACTIONS,
} from '../../../../../../core/analytics/events';
import { isEmpty } from '../../../../../../core/util/empty';

const IncreasedDemandBulletPoint = () => {
  const {
    location,
    location: { id, uclId, phone },
  } = useContext(LocationContext);

  const trackCallClinicClick = () => {
    const trackingProperties = {
      action: CDP_COVID_TEST_ACTIONS.CLICK_CALL_CLINIC,
      locationId: id,
      uclId,
    };
    analyticsTrackEvent(CDP_COVID_TEST_SECTION, trackingProperties);
  };

  if (isEmpty(phone)) {
    return (
      <li>
        <StyledBody>
          An increase in demand may result in longer wait times. Call the clinic for the latest
          estimates.
        </StyledBody>
      </li>
    );
  }

  return (
    <li>
      <StyledBody>
        An increase in demand may result in longer wait times.{' '}
        <a href={`tel:${location.phone}`} onClick={trackCallClinicClick}>
          Call the clinic
        </a>{' '}
        for the latest estimates.
      </StyledBody>
    </li>
  );
};

export default IncreasedDemandBulletPoint;
